import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { MAX_FLIGHT_RANGE, FREE_FLIGHT_RANGE } from "@/constants/membership";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      description:
        "Our real-time feature lets you search for flight information between any two airports. It's perfect for planning trips, tracking flights, or staying updated on routes worldwide.  This feature allows you to access up-to-the-minute data and details for any airport pair you have in mind. ",
    },
    {
      title: "1, Sign up / Log in",
      description:
        "Sign up for an account. To unlock the full capabilities of our real-time search feature, a free account is needed. If you opt to sign up or log in using your email, a magic link will be sent to your email address for easy access.",
      img: "https://img.awardtool-api.com/guides/search_1.png",
    },
    {
      title: "2. Searching",
      description:
        "From the main page, select your departure and arrival airports. Free users can enjoy complimentary roundtrip search, a " + FREE_FLIGHT_RANGE + "-day range search and up to 3 airport-pair searches. Pro users, on the other hand, can conduct searches with up to " + MAX_FLIGHT_RANGE + " entries. Each entry comprises one origin, one arrival, one way, and one day. With a " +
        MAX_FLIGHT_RANGE +
        "-entry search, a Pro user can explore a single airline route for up to " +
        MAX_FLIGHT_RANGE +
        " days. Our system will automatically indicate the number of airports or date ranges you can select.",
      img: "https://img.awardtool-api.com/guides/search_2.png",
    },
    {
      title: "3. Sorting and Filtering",
      description:
        "We offer a variety of sorting and filtering options to simplify the process of finding the most suitable flights for your needs.",
      img: "https://img.awardtool-api.com/guides/search_3.png",
    },
    {
      title: "4. Viewing Flight Details and Booking Options",
      description:
        "We provide you with information on how to transfer points and provide links to the transfer portal. For most airline programs, we also supply links to the respective airline websites for your convenience in booking flights.",
      img: "https://img.awardtool-api.com/guides/search_4.png",
    },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
